import * as React from 'react';
import { useBloomreachPageRoutes } from '@grandvisionhq/bloomreach';
import { Button } from '@grandvisionhq/common';
import { Text, Heading } from '@grandvisionhq/elements';
import { useIntl } from '@grandvisionhq/state';
import { QueryString, DateUtils } from '@grandvisionhq/utils';
import { usePreferredStore } from '../../../../Profile/hooks/use-preferred-store.js';
import AppointmentsList from '../AppointmentsList/AppointmentsList.js';

const AppointmentBody = ({ appointments  })=>{
    const { getLabel  } = useIntl();
    const { data , error: storeError  } = usePreferredStore();
    const storeId = data === null || data === void 0 ? void 0 : data.globalStoreId;
    const { routes  } = useBloomreachPageRoutes();
    var ref;
    const bookAppointmentRoute = (ref = routes['appointment-book']) !== null && ref !== void 0 ? ref : '';
    const getBookAppointmentRoute = !storeId || storeError ? bookAppointmentRoute : `${bookAppointmentRoute}/what${QueryString.stringify({
        storeId: String(storeId)
    })}`;
    const upcomingAppointments = appointments.filter((appointment)=>!DateUtils.isDateBefore(appointment.startTime, new Date())
    );
    const pastAppointments = appointments.filter((appointment)=>DateUtils.isDateBefore(appointment.startTime, new Date())
    ).sort((a, b)=>a.startTime < b.startTime ? 1 : -1
    ) // Descending order on past appointments
    ;
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Text, null, getLabel('appointments.overview.message')), /*#__PURE__*/ React.createElement(Button, {
        href: getBookAppointmentRoute,
        caption: getLabel('appointments.bookAppointment'),
        size: "small",
        className: "appointment-body__button",
        variant: "outline"
    }), /*#__PURE__*/ React.createElement(Heading, {
        variant: "small",
        className: "appointment-body__heading"
    }, getLabel('account.appointments.upcoming')), upcomingAppointments.length < 1 ? /*#__PURE__*/ React.createElement(Text, null, getLabel('appointments.noAppointments.message')) : /*#__PURE__*/ React.createElement(AppointmentsList, {
        appointments: upcomingAppointments
    }), /*#__PURE__*/ React.createElement(Heading, {
        variant: "small",
        className: "appointment-body__heading"
    }, getLabel('account.appointments.past')), pastAppointments.length < 1 ? /*#__PURE__*/ React.createElement(Text, null, getLabel('appointments.noPastAppointments.message')) : /*#__PURE__*/ React.createElement(AppointmentsList, {
        appointments: pastAppointments
    }));
};

export { AppointmentBody as default };
//# sourceMappingURL=AppointmentBody.js.map
